import { z } from 'zod';
import { createPillarApiWithOptions, LogIngestRequestSchema, } from '@pillar-portal/api-types/samba';
const TraceHeaderSchema = z.string().min(1);
export class PillarLogTransportCore {
    getPortalUrl;
    getRequestHeaders;
    getTraceContextHeader;
    customFetch;
    constructor(config) {
        this.getPortalUrl = config.getPortalUrl;
        this.getRequestHeaders = config.getRequestHeaders ?? (async () => ({}));
        this.getTraceContextHeader = config.getTraceContextHeader ?? (() => null);
        this.customFetch = config.customFetch;
    }
    async send(entry, options) {
        await this.sendBatch([entry], options);
    }
    async sendBatch(entries, _options) {
        const payload = LogIngestRequestSchema.parse({
            entries,
        });
        const requestHeaders = await this.getRequestHeaders();
        const traceHeaderValue = this.getTraceContextHeader();
        const traceHeader = traceHeaderValue
            ? TraceHeaderSchema.parse(traceHeaderValue)
            : undefined;
        const pillarApi = createPillarApiWithOptions({
            baseUrl: buildApiBaseUrl(this.getPortalUrl()),
            fetchImplementation: this.customFetch,
            getRequestHeaders: () => {
                return {
                    ...requestHeaders,
                    ...(traceHeader ? { 'X-Cloud-Trace-Context': traceHeader } : {}),
                };
            },
        });
        await pillarApi.loggingApi.ingestLogs(payload);
    }
}
function buildApiBaseUrl(portalUrl) {
    const baseUrl = portalUrl.endsWith('/') ? portalUrl : `${portalUrl}/`;
    const url = new URL('api', baseUrl);
    return url.toString();
}
//# sourceMappingURL=index.js.map